import React, { useContext, useEffect, useRef } from "react";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import { getAboutUsDetails, getSaluteDetails, getTeamDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
import AboutContent from "../About/AboutContent";
import "react-modal-video/css/modal-video.css";
import ReactPlayer from "react-player";
const PastEvents = () => {
  const { appState, dispatch } = useContext(AppContext);
  const { aboutUs, aboutUsLoader, salute, saluteLoader } = appState;
  const myRef = useRef(null);
  const pastEvents = salute.salutes_section?.filter(s => s.highlist_title === "Our Past Events")?.[0] ?? [];
  useEffect(() => {
    getAboutUsDetails(appState, dispatch);
    getTeamDetails(appState, dispatch);
    getSaluteDetails(appState, dispatch)
  }, []);

  return (
    <>
      {aboutUsLoader ? (
        <div className="home-spinner">
          <ClipLoader color={"#2A5350"} loading={true} size={60} />
        </div>
      ) : (
        Object.keys(aboutUs).length && (
          <>
            <Breadcrumb
              pageName="Past Events"
              pageTitle="Past Events"
              id={`#${aboutUs.header_services_section.title}`}
              image={aboutUs.header_services_section.banner_image}
              myRef={myRef}
            />
            <>
              {
                saluteLoader ?
                  <div className='home-spinner'>
                    <ClipLoader color={"#2A5350"} loading={true} size={60} />
                  </div>
                  :
                  Object.keys(salute).length &&
                  <>
                    <div ref={myRef}>
                      {
                        salute.salutes_section && salute.salutes_section.length &&
                        salute.salutes_section
                          .filter(s => s.highlist_title ===
                            "Our Past Events"
                          )
                          .map(section => {
                            return (
                              section.services_list.length > 0 &&
                              <>
                                {
                                  <div className="portfolio-section mb-50" id="project">
                                    <div className="container">
                                      <div className="section-title2 primary3">
                                        <h2>{section.highlist_title}</h2>
                                        <p className="para">
                                          {section.sub_title}
                                        </p>
                                      </div>
                                      <div className="row position-relative g-4">
                                        {section.services_list.map((item) => {
                                          return (
                                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={item.id}>
                                              <div className="portfolio-item1" >
                                                <div className="glass-effect space">
                                                  <div className="portfolio-img">
                                                    {
                                                      item.icon_image &&
                                                      <img alt="portfolio-img" src={item.icon_image} className="img-fluid" />
                                                    }
                                                  </div>
                                                  <div className="portfolio-content">
                                                    <span>{section.highlist_title}</span>
                                                    <h4>
                                                      <p>{item.title}</p>
                                                    </h4>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                }
                              </>
                            )
                          })
                      }
                    </div>
                  </>
              }
            </>
            <div className="mb-100">
              <div className="container">
                <div className="section-title2 primary3">
                  <span>-Our Past Virtual Conference-</span>
                  <h2>Our Past Virtual Conference</h2>
                  <p className="para">
                    The immensity of the ROFDA organization, which spans the
                    entire nation, builds a solid cooperative foundation that is
                    profitable to all of our members. We intend to collaborate
                    and assist our members as they respond to the necessities of
                    respective Independent Retail Grocers.
                  </p>
                </div>
                <div
                  className="video-container"
                  style={{
                    marginTop: "15px",
                  }}
                >
                  <div style={{ margin: "0 7.5px" }} >
                    <ReactPlayer
                      className="react-player"
                      url="https://www.dropbox.com/s/o73x84rxw6mbp8e/ROFDA%202023%20Closing%20Remarks%20Clipped.mp4?dl=0"
                      width="100%"
                      height="300px"
                      controls={true}
                    />
                    <h5 style={{ textAlign: "center", marginTop: "10px" }}>Opening Comments- Jan 31st</h5>
                  </div>
                  <div style={{ margin: "0 7.5px" }} >
                    <ReactPlayer
                      className="react-player"
                      url="https://www.dropbox.com/s/4ur9x4tyc9fbahp/ROFDA%202023%20Opening%20Comments%20Clipped.mp4?dl=0"
                      width="100%"
                      height="300px"
                      controls={true}
                    />
                    <h5 style={{ textAlign: "center", marginTop: "10px" }}>Closing Comments- Feb 1st</h5>
                  </div>
                  <div style={{ margin: "0 7.5px" }} >
                    <ReactPlayer
                      className="react-player"
                      url="https://www.dropbox.com/s/o73x84rxw6mbp8e/ROFDA%202023%20Closing%20Remarks%20Clipped.mp4?dl=0"
                      width="100%"
                      height="300px"
                      controls={true}
                    />
                    <h5 style={{ textAlign: "center", marginTop: "10px" }}>NGA Update</h5>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      )}
    </>
  );
};
export default PastEvents;
